function init() {
  // any row that has 'cards', the link at the bottom aligns horizontally with other cards in the row

  function alignCardButtons() {
    // Only run on desktop/tablet - skip mobile
    if (window.innerWidth < 782) {
      document.querySelectorAll('.entry-content .wp-block-buttons').forEach((button) => {
        button.style.setProperty('margin-top', '', 'important'); // Remove with !important
      });
      return;
    }

    const columnContainers = document.querySelectorAll('.entry-content .wp-block-columns'); // only target entry content (block editor content)

    columnContainers.forEach((container) => {
      const columns = Array.from(container.querySelectorAll('.wp-block-column'));

      if (columns.length < 3) return;

      const columnsWithButtons = columns.filter((column) =>
        column.querySelector('.wp-block-buttons')
      );

      if (columnsWithButtons.length < Math.ceil(columns.length * 0.5)) return;

      // RESET everything first
      columns.forEach((column) => {
        const buttonWrapper = column.querySelector('.wp-block-buttons');
        if (buttonWrapper) {
          buttonWrapper.style.setProperty('margin-top', '', 'important'); // Reset with !important
        }
        column.style.display = '';
        column.style.flexDirection = '';
      });

      // Force layout recalculation
      container.offsetHeight;

      // Set up flex containers
      columns.forEach((column) => {
        column.style.display = 'flex';
        column.style.flexDirection = 'column';
      });

      // Wait for layout to settle
      setTimeout(() => {
        let maxContentHeight = 0;
        const columnData = [];

        columns.forEach((column) => {
          const buttonWrapper = column.querySelector('.wp-block-buttons');
          let contentHeight = 0;

          Array.from(column.children).forEach((child) => {
            if (!child.classList.contains('wp-block-buttons')) {
              contentHeight += child.offsetHeight;
              const styles = getComputedStyle(child);
              contentHeight += parseInt(styles.marginTop) + parseInt(styles.marginBottom);
            }
          });

          columnData.push({
            column,
            buttonWrapper,
            contentHeight,
          });

          maxContentHeight = Math.max(maxContentHeight, contentHeight);
        });

        // Apply margins WITH !important
        columnData.forEach(({ buttonWrapper, contentHeight }) => {
          if (buttonWrapper) {
            const heightDiff = maxContentHeight - contentHeight;

            if (heightDiff > 0) {
              const originalMargin = parseInt(getComputedStyle(buttonWrapper).marginTop) || 0;
              const newMargin = originalMargin + heightDiff;
              // Use setProperty with 'important' flag
              buttonWrapper.style.setProperty('margin-top', `${newMargin}px`, 'important');
            }
          }
        });
      }, 50);
    });
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const debouncedAlign = debounce(alignCardButtons, 300);

  alignCardButtons();
  window.addEventListener('resize', debouncedAlign);
}

export { init as default };
